import {useEffect, useState} from "react";
import {useAuth} from "@/context/use-auth";
import {getCurrentBillingUnitConfig} from "@/services/billing-unit-config-services";
import log from "@/lib/logger";

export function getBillingUnitLabel(unitMinutes: number): string {
    return unitMinutes === 30 ? "½ Std." : "Std.";
}

export function getBillingUnitLabelLong(unitMinutes: number): string {
    return unitMinutes === 30 ? "½ Stunde" : "Stunde";
}

export function useBillingUnitLabel(): { unitLabel: string; unitLabelLong: string; loading: boolean } {
    const {token} = useAuth();
    const [unitMinutes, setUnitMinutes] = useState(60);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!token) return;

        getCurrentBillingUnitConfig(token)
            .then((config) => {
                if (config) {
                    setUnitMinutes(config.unitMinutes);
                }
            })
            .catch((err) => log.error("Failed to load billing unit config", err))
            .finally(() => setLoading(false));
    }, [token]);

    return {
        unitLabel: getBillingUnitLabel(unitMinutes),
        unitLabelLong: getBillingUnitLabelLong(unitMinutes),
        loading,
    };
}
